export enum DashboardContractsPeriods
{
	SETTIMANA = "SETTIMANA",
	MESE = "MESE",
	TRIMESTRE = "TRIMESTRE",
	ANNO = "ANNO"
}
